// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vxyltihbdvdumbwvrwmb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ4eWx0aWhiZHZkdW1id3Zyd21iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1NjMxNjMsImV4cCI6MjA2MjEzOTE2M30.x-qhrfjHetY8yGKWag4xrhgClYM67fcRWcgmk2dS-QA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});